import { Button, DatePicker, notification, Select, Input, Form, message, Typography, Card, Avatar, Col, Row, List, Upload } from "antd"
import { ArrowLeftOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import Title from "antd/es/typography/Title"
import { CreateAccount, GetAccountByID, GetAllPaymentByID, GetAllRoles, GetHistoryRetreats, GetProgressRetreats, UpdateAccount } from "../../../api/AdminService"
import { useNavigate, useParams } from "react-router-dom"
import dayjs from "dayjs"
import { useEffect, useRef, useState } from "react"
import { Option } from "antd/es/mentions"
import { CameraIcon } from "lucide-react";
import axios from 'axios';

const { Text } = Typography
const AdminDetailAccount = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const { id } = useParams();
    const [roles, setRoles] = useState([]);
    const [HistoryRetreat, setHistoryRetreat] = useState([]);
    const [Payments, setPayments] = useState([]);
    const [userData, setUserData] = useState([]);
    const [Edit, setEdit] = useState(false)
    const [retreatProgress, setRetreatProgress] = useState({});
    const validatePassword = (password) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/
        return regex.test(password)
    }
    const [Loading, setLoading] = useState(false);
    const GetAllRole = () => {
        GetAllRoles().then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setRoles(res.data)
            }
        })
    }

    const HistoryRetreats = (id) => {
        GetHistoryRetreats(id).then(res => {
            if (res.status === 200) {
                console.log(res.data.data)
                setHistoryRetreat(res.data.data)
                res.data.data.forEach(retreat => {
                    ProgressRetreat(retreat.id);
                });
            }
        })
    }

    const ProgressRetreat = (id) => {
        GetProgressRetreats(id).then(res => {
            if (res.status === 200) {
                console.log(res.data);
                setRetreatProgress(prev => ({ ...prev, [id]: res.data?.currentProgress }));
            }
        })
    }

    const GetPayments = (id) => {
        GetAllPaymentByID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data.data)
                setPayments(res.data.data)
            }
        })
    }

    const fileInputRef = useRef(null);

    const handleCameraClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };


    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('image', file);

            try {
                const response = await axios.put('https://plum-village.azurewebsites.net/api/accounts/avatar', formData, {
                    headers: {
                        'accept': 'text/plain',
                        Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
                    },
                });

                console.log("Avatar uploaded successfully:", response.data);
                window.location.reload();
            } catch (error) {
                console.error("Error uploading avatar:", error.response ? error.response.data : error.message);
            }
        }
    };

    const GetUserByID = (id) => {
        console.log(id)
        GetAccountByID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setUserData(res.data)
                form.setFieldsValue({
                    avatar: res.data?.avatar,
                    email: res.data?.email,
                    phoneNumber: res.data?.phoneNumber,
                    firstName: res.data?.firstName,
                    lastName: res.data?.lastName,
                    dateOfBirth: dayjs(res.data?.dateOfBirth, 'YYYY-MM-DD'),
                    gender: res.data?.gender,
                    role: res.data?.role,
                    status: res.data?.status,
                })
            }
        })
    }

    useEffect(() => {
        GetAllRole();
    }, [])

    useEffect(() => {
        GetUserByID(id);
        HistoryRetreats(id);
        GetPayments(id);
    }, [])

    const onFinish = (values) => {
        console.log('Received values of form:', values);
        setLoading(true);
        if (values.oldPassword || values.newPassword) {
            if (!values.oldPassword || !values.newPassword) {
                notification.error({ message: 'Both old and new password must be provided to change password.' })
                setLoading(false);
            }
            else if (!validatePassword(values.oldPassword)) {
                notification.error({ message: 'Old password is incorrect or does not meet the requirements.' })
                setLoading(false);
            }

            else if (!validatePassword(values.newPassword)) {
                notification.error({ message: 'New password does not meet the requirements.' })
                setLoading(false);
            }
            else {
                UpdateAccount(id, values.oldPassword, values.newPassword, values.firstName, values.lastName,
                    values.dateOfBirth ? dayjs(values.dateOfBirth).format('YYYY-MM-DD') : null,
                    values.gender, values.status).then(res => {
                        if (res.status === 201) {
                            console.log(res)
                            notification.success({
                                message: "Update Account Successfully"
                            })
                            form.resetFields(['oldPassword', 'newPassword'])
                            setEdit(false);
                            setLoading(false);
                            GetUserByID(id);

                        }
                    }).catch(err => {
                        console.log(err)
                        notification.error({
                            message: `${err.response.data.message}`
                        })
                        setLoading(false);
                    })

            }
        } else {
            UpdateAccount(id, values.oldPassword, values.newPassword, values.firstName, values.lastName,
                values.dateOfBirth ? dayjs(values.dateOfBirth).format('YYYY-MM-DD') : null,
                values.gender, values.status).then(res => {
                    if (res.status === 201) {
                        console.log(res)
                        notification.success({
                            message: "Update Account Successfully"
                        })
                        form.resetFields(['oldPassword', 'newPassword'])
                        setEdit(false);
                        setLoading(false);
                        GetUserByID(id);

                    }
                }).catch(err => {
                    console.log(err)
                    notification.error({
                        message: `${err.response.data.message}`
                    })
                    setLoading(false);
                })

        }

    }


    return (
        <div style={{ minHeight: '96.5vh', Width: '100%' }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>

            <div style={{ maxWidth: 600, margin: 'auto', padding: '24' }}>
                <Title level={2} style={{ textAlign: 'left', marginBottom: '24' }}>
                    Account
                </Title>
                {Edit ? (
                    <>
                        <Form
                            onFinish={onFinish}
                            form={form}
                        >
                            <Card title="Basic Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: '20px' }}>
                                <Form.Item name={"firstName"} label="First Name" rules={[{ required: true, message: 'Requiring first name' }]}>
                                    <Input
                                        placeholder="Input First Name"
                                    />
                                </Form.Item>
                                <Form.Item name={"lastName"} label="Last Name" rules={[{ required: true, message: 'Requiring last name' }]}>
                                    <Input
                                        placeholder="Input Last Name"
                                    />
                                </Form.Item>
                                <Form.Item name={"dateOfBirth"} label="Date of Birth" rules={[{ required: true, message: 'Requiring date of birth' }]}>
                                    <DatePicker />
                                </Form.Item>
                                <Form.Item name={"gender"} label="Gender" rules={[{ required: true, message: 'Requiring Gender' }]}>
                                    <Select
                                        placeholder='Choose Gender'
                                    >
                                        <Option key={1} value="Male">Male</Option>
                                        <Option key={2} value="FeMale">FeMale</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item name={"status"} label="Choose status"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Requiring Status',
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Choose status"
                                    >
                                        <Option key={1} value={'Active'}>
                                            Active
                                        </Option>
                                        <Option key={2} value={'InActive'}>
                                            InActive
                                        </Option>
                                        <Option key={3} value={'Pending'}>
                                            Pending
                                        </Option>

                                    </Select>
                                </Form.Item>
                            </Card>
                            <Card title="Change Password" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: '20px' }}>
                                <Form.Item name={"oldPassword"} label="Old Password" >
                                    <Input.Password
                                        placeholder="Input Old Password"
                                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                    />
                                </Form.Item>
                                <Form.Item name={"newPassword"} label="New Password" extra={
                                    <Text type="secondary">
                                        Password must be at least 8 characters long and include uppercase, lowercase, and special characters.
                                    </Text>
                                } >
                                    <Input.Password
                                        placeholder="Input New Password"
                                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                    />
                                </Form.Item>
                            </Card>
                            <Form.Item >
                        <Button block type="primary" htmlType="submit" loading={Loading}>
                            {Loading ? "Processing..." : "Confirm Update"}
                        </Button>
                    </Form.Item>
                        </Form>

                    </>
                ) : (
                    <div style={{ marginBottom: '20px' }}>
                        <Form
                            form={form}
                            name="wrap"
                            labelAlign="left"
                            labelWrap
                            labelCol={{ flex: '150px' }}
                        >
                            <Card style={{ marginBottom: '20px' }}>
                                <Row>
                                    <Col span={8}>
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            <Avatar size={150} src={ userData.avatar || '/person.png'} style={{ marginRight: '16px' }} />
                                            <div style={{
                                                position: 'absolute',
                                                bottom: '10px',
                                                right: '10px',
                                                backgroundColor: 'white',
                                                borderRadius: '50%',
                                                padding: '5px',
                                                cursor: 'pointer'
                                            }} onClick={handleCameraClick}>
                                                <CameraIcon />
                                            </div>
                                        </div>
                                    </Col>
                                
                                    <Col span={16} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div>
                                                <h1 style={{ fontWeight: 'bold', fontSize: '20px' }}>{userData.firstName} {userData.lastName}</h1>
                                                <h3 style={{ fontSize: '15px' }}>{userData.role}</h3>
                                            </div>
                                            <Form.Item style={{ margin: 0 }}>
                                                <Button type="primary" onClick={() => setEdit(true)}>
                                                    Update User Profile
                                                </Button>
                                            </Form.Item>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                            <Card title="Contact Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                <Form.Item name={"email"} label={<span style={{ fontSize: '16px' }}>Email</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                >
                                    <Input disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Input Email"
                                    />
                                </Form.Item>
                                <Form.Item name={"phoneNumber"} label={<span style={{ fontSize: '16px' }}>Phone Number</span>}
                                    style={{ padding: '8px' }}
                                >
                                    <Input disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Input Phone Number"

                                    />

                                </Form.Item>
                            </Card>
                            <Card title="Basic Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                <Form.Item name={"firstName"} label={<span style={{ fontSize: '18px' }}>First Name</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                >
                                    <Input disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Input First Name"
                                    />
                                </Form.Item>
                                <Form.Item name={"lastName"} label={<span style={{ fontSize: '18px' }}>Last Name</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                >
                                    <Input
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Input Last Name"
                                    />
                                </Form.Item>
                                <Form.Item name={"dateOfBirth"} label={<span style={{ fontSize: '18px' }}>Date of Birth</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                >
                                    <DatePicker disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Input Date Of Birth"
                                    />
                                </Form.Item>
                                <Form.Item name={"gender"} label={<span style={{ fontSize: '18px' }}>Gender</span>}
                                    style={{ padding: '8px  ' }}
                                >
                                    <Input disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Input gender"
                                    />
                                </Form.Item>
                            </Card>
                            {HistoryRetreat.length > 0 ? (
                                <Card title="Course Studying" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                    <List
                                        dataSource={HistoryRetreat}
                                        renderItem={retreat => (
                                            <List.Item key={retreat.id}>
                                                <List.Item.Meta
                                                    avatar={<img src={retreat.retreatImages[0].url} style={{ width: 100, height: 100, borderRadius: '4px' }} />}
                                                    title={retreat.name}
                                                    description={
                                                        <>
                                                            <p>Status: {retreat.status}</p>
                                                            <p>Start Date: {retreat.startDate}</p>
                                                        </>
                                                    }
                                                />
                                                <div>{retreatProgress[retreat.id]}</div>
                                            </List.Item>
                                        )}
                                    />
                                </Card>
                            ) : (
                                <></>
                            )}

                            {Payments.length > 0 ? (
                                <Card title="Payment" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                    <List
                                        dataSource={Payments}
                                        renderItem={payment => (
                                            <List.Item key={payment.id}>
                                                <List.Item.Meta
                                                    title={payment.retreatName}
                                                    description={
                                                        <>
                                                            <p>paymentMethod: {payment.paymentMethod}</p>
                                                            <p>status: {payment.status}</p>
                                                        </>
                                                    }
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </Card>
                            ) : (
                                <></>
                            )}
                            <Form.Item>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    accept="image/*"
                                />
                            </Form.Item>
                        </Form>
                    </div>

                )}


            </div>
        </div>
    )

}
export default AdminDetailAccount